import dayjs from 'dayjs'

export default function renderDate(datetime: string) {
    if (!datetime) return ''
    return dayjs(datetime).format('DD.MM.YYYY')
}
